/* eslint-disable no-use-before-define */
import React, { Component } from 'react';
import Relay from 'react-relay/classic';
import { SnackBarHelper } from '@lyearn-team/frontend-components';
import c from 'classnames';
import PropTypes from 'prop-types';
import Radium from 'radium';
import $j from 'jquery';
import reportRequest from 'helper/ReportingDashboard';
import Events from 'helper/ReportingDashboard/utils/eventsList';

import { interactionsBlocked } from '../../../../helper/blockUserInteractionHelper';
import Icon from '../../../../helper/Icon';
import AddTimeMutation from '../../../mutations/AddTimeMutation';
import User from '../../../../helper/currentUser';
import ReactMediaPlayer from '../../../../components/ReactMediaPlayer/ReactMediaPlayer';
import CardInfo from './CardInfo';
import CardProgress from './CardProgress';
import AssignmentStatus from './AssignmentStatus';
import UnsubmitAssignmentMutation from '../../../mutations/UnsubmitAssignmentMutation';
import './CardTopView.css';

const user = new User();
const kProgressCicleRadius = 14.5;
const addTimeSeconds = 20;
window.__disableAddTime = false;

const mediaPlaying = () => {
  const mediaPlayers = $j('#CardInternalContainer').find('audio, video');
  let isPlaying = false;
  mediaPlayers.each((index, elem) => {
    if (!!elem && typeof elem.paused === 'boolean' && elem.paused === false) {
      isPlaying = true;
    }
  });
  return isPlaying;
};

const manipulateTimeForMediaPlaybackRate = timeSpent => {
  let maxPlaybackRate = 1;
  try {
    const media = $j('#CardInternalContainer').find('audio, video');

    media.each((index, elem) => {
      if (
        !!elem &&
        typeof elem.paused === 'boolean' &&
        elem.paused === false &&
        typeof elem.playbackRate === 'number'
      ) {
        if (elem.playbackRate > maxPlaybackRate) {
          maxPlaybackRate = elem.playbackRate;
        }
      }
    });

    return timeSpent * maxPlaybackRate;
  } catch (e) {
    return timeSpent * maxPlaybackRate;
  }
};

@Radium
class CardTopView extends Component {
  static propTypes = {
    rootQ: PropTypes.object.isRequired
  };

  static contextTypes = {
    showLoading: PropTypes.func,
    hideLoading: PropTypes.func,
    getFeatureFlag: PropTypes.func
  };

  currentTickerTime = 0;
  forcedMarkedInComplete = false;

  UNSAFE_componentWillMount() {
    this.currentTickerTime = Date.now();
    this.forcedMarkedInComplete = false;
    this.cardMarkedComplete = false;
    this.cardCompleted =
      this.props.performance && this.props.performance.completionStatus === 'COMPLETE';
    this.courseAlreadyComplete =
      this.props.course &&
      this.props.course.coursePerformance &&
      this.props.course.coursePerformance.completionStatus === 'COMPLETE';
    this.isOptionalClosed = this.props.rootQ.completionType !== 'OPTIONAL';
  }

  componentDidUpdate(prevProps) {
    if (prevProps.rootQ.pid !== this.props.rootQ.pid) {
      this.currentTickerTime = Date.now();
      this.forcedMarkedInComplete = false;
      this.cardMarkedComplete = false;
      this.cardCompleted =
        this.props.performance && this.props.performance.completionStatus === 'COMPLETE';
      this.isOptionalClosed = this.props.rootQ.completionType !== 'OPTIONAL';
    }
  }

  componentWillUnmount() {
    this.checkTicker();
    this.courseAlreadyComplete = false;
  }

  getAnswerCount() {
    let answerCount = 0;
    const questionAnswers = this.props.rootQ.questionAnswers;
    questionAnswers &&
      questionAnswers.map(questionItem => {
        const answer = questionItem.answer;
        if (answer && answer.length > 0 && !!answer[0].response) {
          answerCount += 1;
        }
      });
    return answerCount;
  }

  unSubmitClicked = () => {
    if (interactionsBlocked()) {
      return false;
    }
    this.context.showLoading();
    const mutation = new UnsubmitAssignmentMutation(
      {
        rootOfferId: this.props.course.pid,
        cardId: this.props.rootQ.pid,
        userId: user.id()
      },
      {
        onSuccess: s => {
          this.context.hideLoading();
          /* this.props.lessonProgressChangeCallback(
            this.props.rootQ.pid,
            this.props.rootQ.performance && this.props.rootQ.performance.scaledProgressMeasure,
            this.props.rootQ
          ); */
          console.debug(s);
        },
        onFailure: t => {
          this.context.hideLoading();
          const error = t.getError() || new Error('Mutation failed.');
          console.error(error);
          SnackBarHelper.showSnackbar({
            label: 'Error occurred, please try again.',
            status: 'error'
          });
        }
      }
    );
    mutation.commit();
  };

  narratButtonClick = () => {
    this.props.narratClick();
  };

  // This functions is called from ASSIGNMENT cards, when
  // completed, using .refs to this(CardtopView) component
  assignmentCardCompleted = completedNow => {
    if (completedNow === true) {
      const courseComplete = this.props.course.coursePerformance.completionStatus === 'COMPLETE';
      if (!this.courseAlreadyComplete && courseComplete) {
        this.isCourseMarkedComplete = courseComplete;
      }
      this.courseAlreadyComplete = courseComplete;
    }
  };

  renderReactMediaPlayer = onlySeekbar => {
    if (onlySeekbar) {
      return (
        <ReactMediaPlayer
          autoPlay={true}
          onlySeekbar={true}
          currentTime={5}
          src={this.props.narrationUrl}
        />
      );
    }
    return <ReactMediaPlayer autoPlay={true} src={this.props.narrationUrl} />;
  };

  renderExitButton = isDesktop => {
    if (this.props.isLiveClass) {
      return null;
    }

    if (isDesktop) {
      return (
        <div
          className="indexButtonContainer desktopExitButton"
          onClick={this.props.backToCourse}
          role="presentation"
        >
          <Icon icon="arrow-back" size="17px" viewBox="4 4 16 16" fill="var(--color-black3)" />
        </div>
      );
    }
    return (
      <div className="mobileExitBtn" onClick={this.props.backToCourse} role="presentation">
        <Icon icon="close" size="17px" viewBox="4 4 16 16" fill="var(--color-black3)" />
      </div>
    );
  };

  closeOptional = () => {
    this.isOptionalClosed = true;
    this.setState({});
  };

  renderIndexBtn = hide => (
    <div
      className={'indexButtonContainer' + (hide ? ' notVisible' : '')}
      onClick={hide ? () => {} : this.props.cardListMenuBtn}
      role="presentation"
    >
      <div className="indexSlideBtn">
        <Icon icon="menu-hamburger" viewBox="0 0 20 18" fill="#929DAE" size="1.1em" />
      </div>
    </div>
  );

  doAddTimeMutation = timeSpent => {
    // Less string completion check
    const allowAddTime =
      this.props.rootQ.completionType === 'TIME_BASED' &&
      this.props.rootQ.lessStrictCompletion &&
      mediaPlaying();

    if (window.__disableAddTime || this.props.previewCourse || this.props.guestMode) {
      return false;
    }

    if (this.props.isLiveClass && this.props.isLiveClassTeacher) {
      return false;
    }

    if (interactionsBlocked()) {
      return false;
    }

    // if (!allowAddTime && ((!window.isActive) || this.props.cardLocked)) {
    if (this.props.cardLocked || (!allowAddTime && !window.isActive)) {
      return false;
    }

    const newTimeSpent = manipulateTimeForMediaPlaybackRate(timeSpent);

    this.currentTickerTime = Date.now(); // RESET ticker when 20 seconds timer complete
    const courseId = this.props.course.pid;
    const courseName = this.props.course.name;
    const cardId = this.props.rootQ.pid;
    const lessonName = this.props.rootQ.name;

    const mutation = new AddTimeMutation({
      mainId: this.props.rootQ.performance && this.props.rootQ.performance.id,
      cardId,
      time: Math.round(newTimeSpent),
      courseId,
      userId: user.id(),
      coursePerformanceId:
        this.props.course.coursePerformance && this.props.course.coursePerformance.id,
      pathId: this.props.pathInfo && this.props.pathInfo.pid,
      pathGraphId: this.props.pathInfo && this.props.pathInfo.id,
      userGraphId: this.props.userObj.id
    });
    mutation.commit({
      onSuccess: async () => {
        const lessonIndex = this.props.rootQ.globalPosition;
        /* this.props.lessonProgressChangeCallback(
          this.props.rootQ.pid,
          this.props.rootQ.performance && this.props.rootQ.performance.scaledProgressMeasure,
          this.props.rootQ
        ); */
        reportRequest(
          Events.TIME_SPENT,
          {
            courseId,
            courseName,
            cardId,
            lessonIndex,
            lessonName
          },
          {
            newTimeSpent
          }
        );
      },
      onFailure: t => {
        SnackBarHelper.showSnackbar({
          label: 'Something went wrong! Please reload the page.',
          status: 'error'
        });
        console.error('Failed at AddTimeMutation', t.getError());
      }
    });
    return true;
  };

  addTime = () => this.doAddTimeMutation(20);

  checkTicker = () => {
    let seconds = (Date.now() - this.currentTickerTime) / 1000;
    seconds = seconds > addTimeSeconds ? addTimeSeconds - 1 : seconds;
    if (seconds > 2 && seconds < addTimeSeconds) {
      this.doAddTimeMutation(seconds);
    }
  };

  render() {
    // const isDarkTheme = this.context.getFeatureFlag && this.context.getFeatureFlag('dark-theme');
    const isDarkTheme = this.props.isDarkTheme;

    const markCompleteShow =
      false &&
      this.props.rootQ.performance &&
      this.props.rootQ.type !== 'assignmentCard' &&
      this.props.rootQ.resource.type !== 'scorm' &&
      process.env.MY_ENV !== 'production';
    const isTimeBased = this.props.rootQ.completionType === 'TIME_BASED';
    const isScrollBased = this.props.rootQ.completionType === 'SCROLL_BASED';
    const leftMarginSideView = isDarkTheme ? styles.left400 : styles.left320;
    const isAssignmentCard =
      this.props.rootQ.type ===
      'assignmentCard'; /*  && this.props.rootQ.resource.type !== 'scorm' */
    const isComplete =
      this.props.rootQ.performance && this.props.rootQ.performance.completionStatus === 'COMPLETE';
    const narrationUrl = this.props.narrationUrl;
    const isLiveClass = this.props.isLiveClass;
    return (
      <div
        className={c('cardTopViewContainer', {
          borderBottomGrey2:
            (!isTimeBased && !isScrollBased) || this.props.previewCourse || this.props.guestMode
        })}
        style={
          isLiveClass
            ? [styles.column, styles.absoluteColumn]
            : [
                styles.column,
                styles.fixedColumn,
                this.props.menuOpen && this.props.windowWidth > 767
                  ? leftMarginSideView
                  : styles.leftZero
              ]
        }
      >
        {!this.isOptionalClosed && (
          <div className="isOptionalContainer">
            <div className="isOptionalInnerContainer">This lesson is optional.</div>
            <span className="optionalCloseIcon" onClick={this.closeOptional} role="presentation">
              <Icon icon="close" size="19px" fill="#fff" />
            </span>
          </div>
        )}
        <div className="firstRow">
          {this.props.isScormOnlyCourse
            ? !this.props.previewCourse
              ? this.renderExitButton(true)
              : null
            : this.renderIndexBtn(this.props.hideSideMenu)}

          <div className="cardDetailsContainer">
            <CardInfo
              card={this.props.rootQ}
              isTimeBased={isTimeBased}
              unSubmitClicked={this.unSubmitClicked}
              resubmitClicked={this.props.resubmitClicked}
              windowWidth={this.props.windowWidth}
              course={this.props.course}
              isLiveClass={this.props.isLiveClass}
            />
          </div>

          {this.renderIndexBtn(true)}
        </div>
        {(isTimeBased || isScrollBased) && !this.props.cardLocked && (
          <CardProgress
            ref={ref => (this.cardProgressRef = ref)}
            card={this.props.rootQ}
            isComplete={isComplete}
            isScrollBased={isScrollBased}
          />
        )}
        {isAssignmentCard && isComplete && !this.props.cardLocked && (
          <AssignmentStatus card={this.props.rootQ} />
        )}

        {this.props.windowWidth > 767 && narrationUrl && !this.props.cardLocked ? (
          <div className="narratButton" onClick={this.narratButtonClick} role="presentation">
            <Icon
              icon="headset"
              fill={this.props.showNarration ? 'rgb(10, 191, 241)' : 'rgba(37, 51, 66, 0.298039)'}
              size="1.5em"
            />
          </div>
        ) : null}

        {this.props.windowWidth > 767 && narrationUrl && this.props.showNarration ? (
          <div className="narrationPlayerContainerAbs" style={styles.narrationPlayerContainer}>
            <div style={[styles.arrowUp, { right: markCompleteShow ? '35px' : '5px' }]} />
            {this.renderReactMediaPlayer()}{' '}
          </div>
        ) : null}
        {!this.props.previewCourse && this.renderExitButton(false)}
      </div>
    );
  }
}

const styles = {
  column: {
    position: 'relative'
  },
  fixedColumn: {
    position: 'fixed',
    right: '0px',
    left: '0px',
    transition: 'all 0.5s ease',
    zIndex: '4',
    top: '0px'
  },
  absoluteColumn: {
    position: 'absolute',
    right: '0px',
    left: '0px',
    transition: 'all 0.5s ease',
    zIndex: '4',
    top: '0px'
  },
  leftZero: {
    left: '0px'
  },
  left320: {
    left: '320px'
  },
  left400: {
    left: '400px'
  },
  submissionWrapper: {
    marginRight: '20px',
    maxWidth: '100px',
    minWidth: '100px',
    color: 'white',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    verticalAlign: 'baseline'
  },
  circle: {
    width: 2 * kProgressCicleRadius,
    height: 2 * kProgressCicleRadius,
    minWidth: 2 * kProgressCicleRadius,
    minHeight: 2 * kProgressCicleRadius,
    borderRadius: '50%',
    marginRight: '12px',
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    position: 'absolute'
  },
  textOverflowEllipsis: {
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden'
  },
  submissionText: {
    fontSize: 14,
    textAlign: 'center'
  },
  panelIconPointer: {
    margin: '15px 0px 0px 20px',
    float: 'left'
  },
  iconColor: '#ffffff',
  titleContainer: {
    width: '100%',
    marginLeft: '22px',
    marginRight: '22px',
    fontSize: '17px',
    color: '#555f68',
    lineHeight: '23px',
    marginTop: 21,
    marginBottom: 18
  },
  narratPresent: {},
  topIndexDigits: {
    marginLeft: '17px',
    fontSize: '14px',
    lineHeight: '19px',
    fontWeight: '500',
    color: 'rgba(118,126,134,0.76)'
  },
  invisible: {
    visibility: 'hidden'
  },
  narrationPlayerContainer: {
    position: 'absolute',
    top: '100%',
    right: '10px',
    padding: '16px 0px',
    width: '21.88%',
    zIndex: '2',
    minWidth: '200px'
  },
  arrowUp: {
    borderLeft: '14px solid transparent',
    borderRight: '14px solid transparent',
    borderBottom: '12px solid rgba(43,53,64,0.7)',
    position: 'absolute',
    top: '4px',
    right: '75px'
  },
  submittedText: {
    fontSize: '12px',
    lineHeight: '16px',
    fontWeight: '500',
    color: '#767e86',
    letterSpacing: '0.7px',
    marginLeft: '14px',
    textTransform: 'uppercase',
    marginTop: '3px',
    background: 'rgba(219,226,232,0.64)',
    borderRadius: '2px',
    padding: '4px 16px'
  }
};

export default Relay.createContainer(CardTopView, {
  initialVariables: {
    userId: null
  },
  fragments: {
    rootQ: () => Relay.QL`
      fragment on Card {
        pid
        name
        globalPosition
        type
        duration
        description
        hideMarkComplete
        minScore
        maxScore
        contributeToSuccessStatus
        isGradable
        completionType
        reAttemptAllowed
        lessStrictCompletion
        questionsForReview {
          minReviewCount
          currentReviewCount
        }
        questionAnswers(userId:$userId) {
          answer {
            pid
            response
          }
          answer {
            response
          }
        }
        resource {
          type
          content {
            questions {
              rType
            }
          }
          narrationUrl
        }
        performance(userId: $userId) {
          id
          completionStatus
          successStatus
          timeSpent
          progressMeasure
          rawScore
          actualSubmit
          scaledProgressMeasure
          forceComplete
        }
      }
    `
  }
});
